import { render, staticRenderFns } from "./TwoFactorItem.vue?vue&type=template&id=61907bc4&"
import script from "./TwoFactorItem.vue?vue&type=script&lang=js&"
export * from "./TwoFactorItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports